import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { differenceInYears, startOfToday, format } from 'date-fns';
import Layout from '../../layout/Layout';
import UserRegister from './UserRegister/UserRegister';
import AgeGate from './AgeGate';
import CoppaRegister from './CoppaRegister/CoppaRegister';

const Register = () => {
  const [birthday, setBirthday] = useState(window.sessionStorage.getItem('birthday'));
  const history = useHistory();

  const handleBirthDateSubmit = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    window.sessionStorage.setItem('birthday', formattedDate);
    setBirthday(formattedDate);
  };

  if (birthday === null) {
    return (
      <Layout onBack={() => history.push('/login')}>
        <AgeGate onSubmit={handleBirthDateSubmit} />
      </Layout>
    );
  }

  if (differenceInYears(startOfToday(), new Date(birthday)) < 14) {
    return <CoppaRegister birthday={birthday} />;
  }

  return <UserRegister birthday={birthday} />;
};

export default Register;
